import Router from "@/helpers/router";

import {
  WHATS_NEW_AUDIENCES,
  WHATS_NEW_ICONS,
  WhatsNewEntryI,
} from "../lib/types";

const { LGA, ADMIN } = WHATS_NEW_AUDIENCES;

/**
 * Team → Health → Lead ingestion (C-16 S8, GLE-8406). Dark until
 * `manage/me.features.lead_ingestion`, inside a window from the release
 * (2026-10-31) to release + 14 days; each LGA and Admin sees it on two ET days from the
 * switch-on (C16-D425).
 */
export const LEAD_INGESTION_2026_10_28: WhatsNewEntryI = {
  id: "2026-10-28-lead-ingestion",
  feature: "lead_ingestion",
  startsAt: "2026-10-31T04:00:00.000Z",
  endsAt: "2026-11-14T05:00:00.000Z",
  title: {
    [LGA]: "Lead ingestion is in Team → Health",
    [ADMIN]: "Lead ingestion is in Team → Health",
  },
  intro: {
    [LGA]:
      "Command Center's Lead Ingestion tab moved into the platform, read from your workspace's lead lists.",
    [ADMIN]:
      "Command Center's Lead Ingestion tab moved into the platform, read from each workspace's lead lists.",
  },
  sections: [
    {
      id: "lead-ingestion",
      audiences: [LGA, ADMIN],
      icon: WHATS_NEW_ICONS.HEALTH,
      title: "Team → Health → Lead ingestion",
      items: [
        "Every lead list since January 2025, newest first: contacts, how many were penetrated and completed, dials and meetings.",
        "Open a list for its lead statuses, its cold leads by dials and its call outcomes.",
        "Filter customer or caller lists, search by list or campaign, and sort any column.",
      ],
      link: {
        label: "Open Lead ingestion",
        href: Router.manageHealth("lead-ingestion"),
      },
    },
  ],
};
